/**
 * How the connections onboarding wizard's integration step behaves for every project in a program.
 *
 * Mirrors `ConnectionsWizardIntegrationStep` on the backend, carried in the `CONNECTIONS_WIZARD`
 * program rule's JSONB payload.
 */
export enum WIZARD_INTEGRATION_STEP {
  REQUIRED = 'REQUIRED',
  OPTIONAL = 'OPTIONAL',
  NOT_APPLICABLE = 'NOT_APPLICABLE'
}

/** Declaration order, which is also the order the option cards render in. */
export function getWizardIntegrationStepAsList(): WIZARD_INTEGRATION_STEP[] {
  return Object.keys(WIZARD_INTEGRATION_STEP)
    .map((key: string) => WIZARD_INTEGRATION_STEP[key]);
}
